@if (product.isDirectlyAvailable || product.isAvailableLater || product.isStockAvailableLater) {
<div class="theme-success-text-color">
	@if (product.isAvailableLater || product.isStockAvailableLater) {
	<span i18n="@@product.more.available">Available from</span>
	<span>{{ getAvailableLaterDate() | customDate:'dd-MM' }}</span>
	}

	@else {
	<span i18n="@@product.later.available">More available from</span>
	<span>{{ getAvailableLaterDate() | customDate:'dd-MM' }}</span>
	}
</div>
}
